export default {
  balance: {
    en: "Balance",
  },
  inBets: {
    en: "In bets",
  },
  toRedeem: {
    en: "To redeem",
  },
  deposit: {
    en: "Deposit",
  },
  freebet: {
    en: "Freebet",
  },
}
